import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, interval } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseComponent } from '../core/base/base.component';
import { CommonTurnViewModel } from '../model/common/turn.view';
import { MainService } from './main.service';

@Component({
  selector: 'ms-main',
  templateUrl: 'main.component.html',
})
export class MainViewComponent extends BaseComponent implements OnInit {
  turnsId: number[] = [];
  patientQuery = '';
  doctorQuery = '';
  specialtyQuery = '';
  showHeading = false;

  constructor(override service: MainService, protected route: Router) {
    super();
  }

  override ngOnInit(): void {
    this.service
      .readSubCatalogs()
      .forEach((subCatalog) => this.subscriptions.push(subCatalog.subscribe()));
    this.subscriptions.push(
      this.service.getShowHeading().subscribe((showHeading) =>
        setTimeout(() => {
          this.showHeading = showHeading;
        }, 0)
      ),
      this.service.getTurnsId().subscribe((ids) => (this.turnsId = ids)),
      this.service
        .getTurnPatientQuery()
        .subscribe((query) => (this.patientQuery = query)),
      this.service
        .getTurnDoctorQuery()
        .subscribe((query) => (this.doctorQuery = query)),
      this.service
        .getTurnSpecialtyQuery()
        .subscribe((query) => (this.specialtyQuery = query)),
      this.service.getUserInformation().subscribe((userInfo) => {
        if (
          userInfo.roles &&
          (userInfo.roles.isVitalSign || userInfo.roles.isDoctor)
        ) {
          this.subscriptions.push(this.getTurns().subscribe());
          if (environment.production) {
            this.subscriptions.push(
              interval(20000).subscribe(() => {
                this.subscriptions.push(this.getTurns().subscribe());
              })
            );
          }
        } else if (userInfo.roles && userInfo.roles.isCounter) {
          this.subscriptions.push(this.getTurns().subscribe());
        }

        if (
          userInfo.enabled &&
          userInfo.temporal &&
          !userInfo.onlyAccount &&
          environment.production
        ) {
          this.route.navigate(['/cuenta']);
        }
      })
    );
  }

  getTurns = (): Observable<CommonTurnViewModel[]> =>
    this.service.readTurns({
      patient: this.patientQuery,
      doctor: this.doctorQuery,
      specialty: this.specialtyQuery,
    });
}
